import React from 'react';
import {
  Badge,
  Box,
  IconName,
  Tooltip,
} from '@usealloy/component-library';

export default function EvaluationHeaderResult({ result }: { result: string }) {
  return result === 'partial' ? (
    <Box alignItems="flex-start" direction="column" style={{ height: '48px', width: 'min-content' }}>
      <div className="bold">Result</div>
      <p className="result partial">
        <Tooltip content="Exited Workflow">
          <Badge icon={IconName.Error} status="danger">
            Partial
          </Badge>
        </Tooltip>
      </p>
    </Box>
  ) : null;
}

